// import React, { useEffect, useMemo, useRef, useState } from "react";
// import api from "../../../api";
// import {
//   Button,
//   Modal,
//   Form,
//   InputGroup,
//   Pagination,
//   Spinner,
//   Badge,
// } from "react-bootstrap";
// import ProductHistoryModal from "./ProductHistoryModal";
// import { usePermissions } from "../../../context/PermissionContext";
// import "./InventoryProductList.css";

// // ---------- CSV helpers ----------
// const toCsv = (rows) => {
//   if (!rows?.length) return "";

//   const headers = Object.keys(rows[0]);

//   const escape = (value) =>
//     value == null
//       ? ""
//       : `${value}`.includes(",") ||
//         `${value}`.includes('"') ||
//         `${value}`.includes("\n")
//       ? `"${`${value}`.replace(/"/g, '""')}"`
//       : `${value}`;

//   return [
//     headers.join(","),
//     ...rows.map((row) => headers.map((header) => escape(row[header])).join(",")),
//   ].join("\n");
// };

// const parseCsv = async (file) =>
//   new Promise((resolve, reject) => {
//     const reader = new FileReader();

//     reader.onerror = reject;

//     reader.onload = () => {
//       try {
//         const text = reader.result;
//         const [headerLine, ...dataLines] = text.split(/\r?\n/).filter(Boolean);
//         const headers = headerLine.split(",").map((h) => h.trim());

//         const rows = dataLines.map((line) => {
//           const parts = [];
//           let current = "";
//           let inQuote = false;

//           for (let i = 0; i < line.length; i++) {
//             const char = line[i];

//             if (char === '"' && line[i + 1] === '"' && inQuote) {
//               current += '"';
//               i++;
//             } else if (char === '"') {
//               inQuote = !inQuote;
//             } else if (char === "," && !inQuote) {
//               parts.push(current);
//               current = "";
//             } else {
//               current += char;
//             }
//           }

//           parts.push(current);

//           const obj = {};
//           headers.forEach((header, index) => {
//             obj[header] = parts[index] ?? "";
//           });

//           return obj;
//         });

//         resolve({ headers, rows });
//       } catch (error) {
//         reject(error);
//       }
//     };

//     reader.readAsText(file);
//   });

// const blankProduct = {
//   name: "",
//   category: "",
//   brand: "",
//   model_no: "",
//   serial_no: "",
//   serial_numbers: "",
//   processor: "",
//   ram_gb: "",
//   ssd_gb: "",
//   hdd_gb: "",
//   purchase_date: "",
//   warranty_date: "",
//   warranty_expiry_date: "",
//   price: "",
//   qty: 1,
//   status: "ACTIVE",
//   has_cpu: false,
//   has_monitor: false,
//   has_mouse: false,
//   has_keyboard: false,
//   has_adapter: false,
// };

// export default function InventoryProductList() {
//   const { can } = usePermissions();
//   const canCreate = can("products", "create");
//   const canEdit = can("products", "edit");
//   const canDelete = can("products", "delete");

//   const [products, setProducts] = useState([]);
//   const [editingProduct, setEditingProduct] = useState(null);

//   const [query, setQuery] = useState("");
//   const [statusFilter, setStatusFilter] = useState("ALL");

//   const [page, setPage] = useState(1);
//   const [perPage, setPerPage] = useState(10);

//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);

//   const fileRef = useRef(null);

//   const [historyOpen, setHistoryOpen] = useState(false);
//   const [selectedProduct, setSelectedProduct] = useState(null);

//   useEffect(() => {
//     fetchProducts();
//   }, []);

//   useEffect(() => {
//     setPage(1);
//   }, [query, statusFilter, perPage]);

//   const fetchProducts = async () => {
//     try {
//       setLoading(true);
//       const res = await api.get(`/products`);
//       setProducts(Array.isArray(res.data) ? res.data : []);
//       setPage(1);
//     } catch (error) {
//       console.error("Error fetching products:", error);
//       alert("Failed to fetch products");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const openHistory = (product) => {
//     setSelectedProduct(product);
//     setHistoryOpen(true);
//   };

//   const openAddModal = () => {
//     setEditingProduct({ ...blankProduct });
//   };

//   const setEditField = (key, value) => {
//     setEditingProduct((prev) => ({
//       ...(prev || {}),
//       [key]: value,
//     }));
//   };

//   const parseSerialList = (text) => {
//     return String(text || "")
//       .split(/[\n,]+/)
//       .map((v) => v.trim())
//       .filter(Boolean);
//   };

//   const formatDate = (value) => {
//     if (!value) return "-";
//     const d = new Date(value);
//     if (Number.isNaN(d.getTime())) return "-";

//     return d.toLocaleDateString("en-IN", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//     });
//   };

//   const toDateInput = (value) => {
//     if (!value) return "";
//     const d = new Date(value);
//     if (Number.isNaN(d.getTime())) return "";

//     const pad = (n) => String(n).padStart(2, "0");

//     return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
//   };

//   const getWarrantyBadge = (status) => {
//     const value = String(status || "NO_WARRANTY").toUpperCase();

//     if (value === "IN_WARRANTY") {
//       return (
//         <Badge className="unit-warranty unit-warranty-active">
//           In Warranty
//         </Badge>
//       );
//     }

//     if (value === "EXPIRED") {
//       return (
//         <Badge className="unit-warranty unit-warranty-expired">
//           Expired
//         </Badge>
//       );
//     }

//     return (
//       <Badge className="unit-warranty unit-warranty-none">
//         No Warranty
//       </Badge>
//     );
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm("Delete this product?")) return;

//     try {
//       await api.delete(`/products/${id}`);
//       await fetchProducts();
//       alert("Product deleted successfully");
//     } catch (error) {
//       console.error("Error deleting product:", error);
//       alert(error?.response?.data?.error || "Failed to delete product");
//     }
//   };

//   const handleSave = async (product) => {
//     if (!product?.name?.trim()) {
//       alert("Product name is required");
//       return;
//     }

//     const isEdit = !!product.id;
//     const serialList = parseSerialList(product.serial_numbers);

//     if (!isEdit && !serialList.length) {
//       alert("Please enter at least one serial number");
//       return;
//     }

//     try {
//       setSaving(true);

//       const payload = {
//         name: product.name?.trim(),
//         category: product.category || "",
//         brand: product.brand || "",
//         model_no: product.model_no || "",

//         serial_no: isEdit ? product.serial_no || "" : undefined,
//         serial_numbers: !isEdit ? serialList : undefined,

//         processor: product.processor || "",
//         ram_gb:
//           product.ram_gb === "" || product.ram_gb == null
//             ? null
//             : Number(product.ram_gb),
//         ssd_gb:
//           product.ssd_gb === "" || product.ssd_gb == null
//             ? null
//             : Number(product.ssd_gb),
//         hdd_gb:
//           product.hdd_gb === "" || product.hdd_gb == null
//             ? null
//             : Number(product.hdd_gb),

//         price: Number(product.price || 0),
//         qty: isEdit ? Number(product.qty || 0) : serialList.length || Number(product.qty || 1),

//         purchase_date: product.purchase_date || null,
//         warranty_date: product.warranty_date || product.purchase_date || null,
//         warranty_expiry_date: product.warranty_expiry_date || null,

//         has_cpu: product.has_cpu ? 1 : 0,
//         has_monitor: product.has_monitor ? 1 : 0,
//         has_mouse: product.has_mouse ? 1 : 0,
//         has_keyboard: product.has_keyboard ? 1 : 0,
//         has_adapter: product.has_adapter ? 1 : 0,
//         status: product.status || "ACTIVE",
//       };

//       if (isEdit) {
//         await api.put(`/products/${product.id}`, payload);
//         alert("Product updated successfully");
//       } else {
//         await api.post(`/products`, payload);
//         alert(
//           serialList.length > 1
//             ? `${serialList.length} products added successfully`
//             : "Product added successfully"
//         );
//       }

//       setEditingProduct(null);
//       fetchProducts();
//     } catch (error) {
//       console.error("Error saving product:", error);
//       alert(error?.response?.data?.error || "Failed to save product");
//     } finally {
//       setSaving(false);
//     }
//   };

//   const specLine = (product) => {
//     if (!product) return "-";

//     const ram = product.ram_gb ? `${product.ram_gb}GB` : "-";
//     const storage = product.ssd_gb
//       ? `${product.ssd_gb}GB SSD`
//       : product.hdd_gb
//       ? `${product.hdd_gb}GB HDD`
//       : "-";

//     return `${product.processor || "-"} / ${ram} / ${storage}`;
//   };

//   const money = (value) => {
//     const number = Number(value ?? 0);
//     return Number.isFinite(number) ? `₹${number.toFixed(2)}` : "-";
//   };

//   const filtered = useMemo(() => {
//     const q = query.trim().toLowerCase();

//     let data = [...products];

//     if (statusFilter !== "ALL") {
//       data = data.filter((product) => product.status === statusFilter);
//     }

//     if (q) {
//       const fields = [
//         "sku",
//         "name",
//         "category",
//         "brand",
//         "model_no",
//         "serial_no",
//         "processor",
//         "warranty_status",
//         "purchase_date",
//         "warranty_expiry_date",
//       ];

//       data = data.filter((product) =>
//         fields
//           .map((field) => product[field])
//           .filter(Boolean)
//           .some((value) => String(value).toLowerCase().includes(q))
//       );
//     }

//     return data;
//   }, [products, query, statusFilter]);

//   const stats = useMemo(() => {
//     return {
//       total: products.length,
//       active: products.filter((p) => p.status !== "INACTIVE").length,
//       inactive: products.filter((p) => p.status === "INACTIVE").length,
//       inWarranty: products.filter((p) => p.warranty_status === "IN_WARRANTY").length,
//       expiredWarranty: products.filter((p) => p.warranty_status === "EXPIRED").length,
//       totalQty: products.reduce((sum, p) => sum + Number(p.qty || 0), 0),
//       totalValue: products.reduce(
//         (sum, p) => sum + Number(p.qty || 0) * Number(p.price || 0),
//         0
//       ),
//     };
//   }, [products]);

//   const totalPages = Math.max(1, Math.ceil(filtered.length / perPage));

//   const pageData = useMemo(() => {
//     const start = (page - 1) * perPage;
//     return filtered.slice(start, start + perPage);
//   }, [filtered, page, perPage]);

//   const exportCsv = (onlyPage = false) => {
//     const rows = onlyPage ? pageData : filtered;

//     if (!rows.length) {
//       alert("No products available to export");
//       return;
//     }

//     const formattedRows = rows.map((product) => ({
//       id: product.id,
//       sku: product.sku,
//       name: product.name,
//       category: product.category,
//       brand: product.brand,
//       model_no: product.model_no,
//       serial_no: product.serial_no,
//       processor: product.processor,
//       ram_gb: product.ram_gb,
//       ssd_gb: product.ssd_gb,
//       hdd_gb: product.hdd_gb,
//       purchase_date: product.purchase_date,
//       warranty_date: product.warranty_date,
//       warranty_expiry_date: product.warranty_expiry_date,
//       warranty_status: product.warranty_status,
//       has_cpu: product.has_cpu ? 1 : 0,
//       has_monitor: product.has_monitor ? 1 : 0,
//       has_mouse: product.has_mouse ? 1 : 0,
//       has_keyboard: product.has_keyboard ? 1 : 0,
//       has_adapter: product.has_adapter ? 1 : 0,
//       price: product.price,
//       qty: product.qty,
//       status: product.status,
//     }));

//     const csv = toCsv(formattedRows);
//     const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });

//     const link = document.createElement("a");
//     link.href = URL.createObjectURL(blob);
//     link.download = `products_${onlyPage ? `page${page}` : "all"}.csv`;
//     link.click();

//     URL.revokeObjectURL(link.href);
//   };

//   const onImportClick = () => fileRef.current?.click();

//   const toNum = (value, def = 0) => {
//     const number = Number(value);
//     return Number.isFinite(number) ? number : def;
//   };

//   const onImportFile = async (event) => {
//     const file = event.target.files?.[0];
//     if (!file) return;

//     try {
//       const { rows } = await parseCsv(file);

//       const cleaned = rows
//         .map((row) => ({
//           name: row.name || row["Product Name"] || row.product_name || "",
//           category: row.category || row.Category || "",
//           brand: row.brand || row.Brand || "",
//           model_no: row.model_no || row.Model || row["Model No"] || "",
//           serial_no: row.serial_no || row.Serial || row["Serial No"] || "",
//           serial_numbers:
//             row.serial_numbers ||
//             row["Serial Numbers"] ||
//             row.serial_no ||
//             row.Serial ||
//             row["Serial No"] ||
//             "",
//           processor: row.processor || row.CPU || "",
//           ram_gb: toNum(row.ram_gb ?? row.RAM),
//           ssd_gb: toNum(row.ssd_gb ?? row.SSD),
//           hdd_gb: toNum(row.hdd_gb ?? row.HDD),
//           purchase_date: row.purchase_date || row["Purchase Date"] || "",
//           warranty_date: row.warranty_date || row["Warranty Date"] || "",
//           warranty_expiry_date:
//             row.warranty_expiry_date ||
//             row["Warranty Expiry Date"] ||
//             row["Warranty Expiry"] ||
//             "",
//           has_cpu: toNum(row.has_cpu ?? row.CPU_Unit) ? 1 : 0,
//           has_monitor: toNum(row.has_monitor ?? row.Monitor) ? 1 : 0,
//           has_mouse: toNum(row.has_mouse ?? row.Mouse) ? 1 : 0,
//           has_keyboard: toNum(row.has_keyboard ?? row.Keyboard) ? 1 : 0,
//           has_adapter: toNum(row.has_adapter ?? row.Adapter) ? 1 : 0,
//           price: toNum(row.price ?? row.Price),
//           qty: toNum(row.qty ?? row.Qty, 1),
//           status:
//             (row.status || "ACTIVE").toUpperCase() === "INACTIVE"
//               ? "INACTIVE"
//               : "ACTIVE",
//         }))
//         .filter((item) => item.name);

//       if (!cleaned.length) {
//         alert("No valid rows found in CSV. Product name is required.");
//         return;
//       }

//       await api.post(`/products/import`, {
//         rows: cleaned,
//       });

//       await fetchProducts();
//       alert(`Imported ${cleaned.length} CSV row(s). SKU generated by backend.`);
//     } catch (error) {
//       console.error("Import error:", error);
//       alert(error?.response?.data?.error || "Import failed. Check console for details.");
//     } finally {
//       event.target.value = "";
//     }
//   };

//   const orgInfo = {
//     name: "Jaipuria Schools",
//     address: "Sector-XX, City, State - 000000",
//     phone: "+91-00000-00000",
//     email: "info@jaipuria.edu",
//   };

//   const esc = (value) =>
//     String(value ?? "")
//       .replace(/&/g, "&amp;")
//       .replace(/</g, "&lt;")
//       .replace(/>/g, "&gt;");

//   const pad2 = (number) => String(number).padStart(2, "0");

//   const formatDMY = (date) => {
//     const dt = date instanceof Date ? date : new Date(date);
//     if (Number.isNaN(dt.getTime())) return "-";
//     return `${pad2(dt.getDate())}-${pad2(dt.getMonth() + 1)}-${dt.getFullYear()}`;
//   };

//   const buildProductSheetHTML = (rows, title = "Product Stock Sheet") => {
//     const today = formatDMY(new Date());
//     const isSingle = rows.length === 1;

//     const bodyRows = rows
//       .map(
//         (row, index) => `
//         <tr>
//           <td>${index + 1}</td>
//           <td>${esc(row.sku ?? "-")}</td>
//           <td>${esc(row.name ?? "-")}</td>
//           <td>${esc(row.model_no ?? "-")}</td>
//           <td>${esc(row.serial_no ?? "-")}</td>
//           <td>${esc(row.processor ?? "-")} / ${row.ram_gb || "-"}GB / ${
//           row.ssd_gb
//             ? `${row.ssd_gb}GB SSD`
//             : row.hdd_gb
//             ? `${row.hdd_gb}GB HDD`
//             : "-"
//         }</td>
//           <td>${formatDMY(row.purchase_date)}</td>
//           <td>${formatDMY(row.warranty_expiry_date)}</td>
//           <td>${esc(row.warranty_status ?? "-")}</td>
//           <td class="num">${money(row.price)}</td>
//           <td class="num">${Number(row.qty ?? 0)}</td>
//           <td>${esc(row.status ?? "-")}</td>
//         </tr>`
//       )
//       .join("");

//     const singleMeta = isSingle
//       ? `
//       <table class="meta">
//         <tr>
//           <td><b>SKU:</b> ${esc(rows[0].sku ?? "-")}</td>
//           <td><b>Name:</b> ${esc(rows[0].name ?? "-")}</td>
//           <td><b>Brand:</b> ${esc(rows[0].brand ?? "-")}</td>
//         </tr>
//       </table>`
//       : "";

//     return `<!DOCTYPE html>
// <html>
// <head>
// <meta charset="utf-8"/>
// <title>${esc(title)}</title>
// <style>
//   @page { size: A4 landscape; margin: 12mm; }
//   html, body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
//   body { font-family: Arial, sans-serif; color: #111827; }
//   .head { display:flex; justify-content:space-between; align-items:flex-start; border-bottom:2px solid #e5e7eb; padding-bottom:10px; margin-bottom:10px; }
//   .brand { font-weight:800; font-size:20px; line-height:1.1; }
//   .muted { color:#6b7280; font-size:12px; }
//   .title { text-align:center; margin:8px 0 12px; font-size:18px; font-weight:800; }
//   .meta { width:100%; border:1px solid #e5e7eb; border-radius:8px; padding:8px; font-size:12px; margin-bottom:10px; border-collapse:separate; border-spacing:0; }
//   .meta td { padding:4px 6px; vertical-align:top; }
//   .table { width:100%; border-collapse:collapse; margin-top:8px; font-size:10px; }
//   .table th, .table td { border:1px solid #e5e7eb; padding:5px 6px; }
//   .table thead th { background:#f9fafb; text-transform:uppercase; letter-spacing:.02em; font-size:9px; color:#6b7280; }
//   .num { text-align:right; font-variant-numeric: tabular-nums; }
//   .sign-grid { display:grid; grid-template-columns:1fr 1fr 1fr; gap:14px; margin-top:18px; }
//   .sign-card { border:1px dashed #cbd5e1; border-radius:8px; padding:10px; }
//   .sign-line { border-top:1px solid #94a3b8; margin-top:28px; }
//   .label { font-size:11px; color:#6b7280; }
//   .foot { margin-top:14px; font-size:11px; color:#6b7280; }
// </style>
// </head>
// <body>
//   <div class="head">
//     <div>
//       <div class="brand">${esc(orgInfo.name)}</div>
//       <div class="muted">${esc(orgInfo.address)}</div>
//       <div class="muted">${esc(orgInfo.phone)} | ${esc(orgInfo.email)}</div>
//     </div>
//     <div class="muted" style="text-align:right">
//       <div>Date: <b>${esc(today)}</b></div>
//       <div>Doc #: ____________</div>
//     </div>
//   </div>

//   <div class="title">${esc(title)}</div>

//   <table class="meta">
//     <tr>
//       <td><b>Total Items:</b> ${rows.length}</td>
//       <td><b>Prepared By:</b> ____________________</td>
//       <td><b>Checked By:</b> ____________________</td>
//     </tr>
//   </table>

//   ${singleMeta}

//   <table class="table">
//     <thead>
//       <tr>
//         <th>#</th>
//         <th>SKU</th>
//         <th>Product</th>
//         <th>Model</th>
//         <th>Serial</th>
//         <th>Spec</th>
//         <th>Purchase</th>
//         <th>Warranty Exp.</th>
//         <th>Warranty</th>
//         <th>Price</th>
//         <th>Qty</th>
//         <th>Status</th>
//       </tr>
//     </thead>
//     <tbody>${bodyRows}</tbody>
//   </table>

//   <div class="sign-grid">
//     <div class="sign-card">
//       <div><b>Recieved By</b></div>
//       <div class="label">Name & Signature</div>
//       <div class="sign-line"></div>
//     </div>
//     <div class="sign-card">
//       <div><b>Received By</b></div>
//       <div class="label">Name & Signature</div>
//       <div class="sign-line"></div>
//     </div>
//     <div class="sign-card">
//       <div><b>Verified By</b></div>
//       <div class="label">Name & Signature</div>
//       <div class="sign-line"></div>
//     </div>
//   </div>

//   <div class="foot">
//     <b>Note:</b> Physical counts should be verified against system records. Report discrepancies within 24 hours.
//   </div>
// </body>
// </html>`;
//   };

//   const printProductRows = (rows, title) => {
//     const printWindow = window.open("", "_blank", "width=900,height=1000");

//     if (!printWindow) {
//       alert("Popup blocked. Please allow popups to print.");
//       return;
//     }

//     const html = buildProductSheetHTML(rows ?? [], title);

//     printWindow.document.open();
//     printWindow.document.write(html);
//     printWindow.document.close();

//     printWindow.onload = () => {
//       try {
//         printWindow.focus();
//       } catch {}
//       printWindow.print();
//     };
//   };

//   const printProductSingle = (row) => {
//     if (!row) return;
//     printProductRows([row], "Product Stock Sheet — Single");
//   };

//   const clearFilters = () => {
//     setQuery("");
//     setStatusFilter("ALL");
//     setPage(1);
//   };

//   const getStatusBadge = (status) => {
//     if (status === "INACTIVE") {
//       return <Badge className="unit-status unit-status-inactive">Inactive</Badge>;
//     }

//     return <Badge className="unit-status unit-status-active">Active</Badge>;
//   };

//   const serialCount = parseSerialList(editingProduct?.serial_numbers).length;
//   const isEditMode = !!editingProduct?.id;

//   return (
//     <div className="unit-page inventory-product-theme">
//       <div className="unit-header">
//         <div>
//           <div className="unit-page-label">Inventory</div>
//           <h2>Product List</h2>
//           <p>
//             Manage inventory products, stock quantity, specifications,
//             warranty details and CSV import/export.
//           </p>
//         </div>

//         <div className="unit-header-actions">
//           <Button className="unit-btn unit-btn-light" onClick={fetchProducts}>
//             <i className="fa-solid fa-rotate" aria-hidden="true"></i>
//             Refresh
//           </Button>

//           <Button className="unit-btn unit-btn-light" onClick={onImportClick}>
//             <i className="fa-solid fa-file-import" aria-hidden="true"></i>
//             Import CSV
//           </Button>

//           {canCreate && (
//             <Button className="unit-btn unit-btn-primary" onClick={openAddModal}>
//               <i className="fa-solid fa-plus" aria-hidden="true"></i>
//               Add Product
//             </Button>
//           )}
//         </div>
//       </div>

//       <input
//         ref={fileRef}
//         type="file"
//         accept=".csv"
//         hidden
//         onChange={onImportFile}
//       />

//       <div className="unit-stats-row unit-top-stats">
//         <div className="unit-stat-card">
//           <span>Total Products</span>
//           <strong>{stats.total}</strong>
//         </div>

//         <div className="unit-stat-card">
//           <span>Active</span>
//           <strong>{stats.active}</strong>
//         </div>

//         <div className="unit-stat-card">
//           <span>Inactive</span>
//           <strong>{stats.inactive}</strong>
//         </div>

//         <div className="unit-stat-card">
//           <span>In Warranty</span>
//           <strong>{stats.inWarranty}</strong>
//         </div>

//         <div className="unit-stat-card">
//           <span>Total Value</span>
//           <strong>{money(stats.totalValue)}</strong>
//         </div>
//       </div>

//       <div className="unit-card">
//         <div className="unit-toolbar">
//           <div>
//             <h5>Product Inventory</h5>
//             <p>Search, filter, add, edit, delete, print and view allocation history.</p>
//           </div>

//           <div className="unit-toolbar-actions">
//             <InputGroup className="unit-search">
//               <InputGroup.Text aria-hidden="true">
//                 <i className="fa-solid fa-magnifying-glass"></i>
//               </InputGroup.Text>

//               <Form.Control
//                 placeholder="Search SKU, name, model, serial, warranty..."
//                 aria-label="Search SKU, name, model, serial, warranty"
//                 value={query}
//                 onChange={(e) => setQuery(e.target.value)}
//               />

//               {query && (
//                 <Button className="unit-clear-btn" onClick={() => setQuery("")}>
//                   Clear
//                 </Button>
//               )}
//             </InputGroup>

//             <Form.Select
//               className="unit-page-size"
//               value={statusFilter}
//               onChange={(e) => setStatusFilter(e.target.value)}
//             >
//               <option value="ALL">All Status</option>
//               <option value="ACTIVE">Active</option>
//               <option value="INACTIVE">Inactive</option>
//             </Form.Select>

//             <Form.Select
//               className="unit-page-size"
//               value={perPage}
//               onChange={(e) => setPerPage(Number(e.target.value))}
//             >
//               <option value={10}>10 rows</option>
//               <option value={25}>25 rows</option>
//               <option value={50}>50 rows</option>
//               <option value={100}>100 rows</option>
//             </Form.Select>

//             <Button className="unit-btn unit-btn-light" onClick={() => exportCsv(true)}>
//               <i className="fa-solid fa-file-csv" aria-hidden="true"></i>
//               Export Page
//             </Button>

//             <Button className="unit-btn unit-btn-light" onClick={() => exportCsv(false)}>
//               <i className="fa-solid fa-file-csv" aria-hidden="true"></i>
//               Export All
//             </Button>

//             <Button
//               className="unit-btn unit-btn-light"
//               onClick={() => printProductRows(filtered, "Product Stock Sheet — All")}
//             >
//               <i className="fa-solid fa-print" aria-hidden="true"></i>
//               Print All
//             </Button>

//             {(query || statusFilter !== "ALL") && (
//               <Button className="unit-btn unit-btn-light" onClick={clearFilters}>
//                 Reset
//               </Button>
//             )}
//           </div>
//         </div>

//         <div className="unit-table-wrapper">
//           {loading ? (
//             <div className="unit-loader">
//               <Spinner animation="border" />
//               <p>Loading products...</p>
//             </div>
//           ) : (
//             <table className="table unit-table product-inventory-table">
//               <thead>
//                 <tr>
//                   <th className="col-sno">S.No.</th>
//                   <th className="col-product">Product</th>
//                   <th className="col-category">Category</th>
//                   <th className="col-model">Model</th>
//                   <th className="col-serial">Serial</th>
//                   <th className="col-spec">Spec</th>
//                   <th className="col-purchase">Purchase</th>
//                   <th className="col-warranty-exp">Warranty Exp.</th>
//                   <th className="col-warranty">Warranty</th>
//                   <th className="col-price">Price</th>
//                   <th className="col-qty">Total Qty</th>
//                   <th className="col-available">Available</th>
//                   <th className="col-allocated">Allocated</th>
//                   <th className="col-status">Status</th>
//                   <th className="product-history">History</th>
//                   <th className="col-actions text-end">Actions</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {pageData.length > 0 ? (
//                   pageData.map((product, index) => (
//                     <tr key={product.id}>
//                       <td className="col-sno">
//                         <span className="unit-id">
//                           #{(page - 1) * perPage + index + 1}
//                         </span>
//                       </td>

//                       <td className="col-product">
//                         <div className="unit-name-box">
//                           <div className="unit-letter">
//                             {product.name?.charAt(0)?.toUpperCase() || "P"}
//                           </div>

//                           <div className="product-text">
//                             <strong title={product.name || "-"}>{product.name}</strong>
//                             <small title={product.sku || "-"}>SKU: {product.sku || "-"}</small>
//                           </div>
//                         </div>
//                       </td>

//                       <td className="col-category">{product.category || "-"}</td>
//                       <td className="col-model" title={product.model_no || "-"}>
//                         {product.model_no || "-"}
//                       </td>
//                       <td className="col-serial" title={product.serial_no || "-"}>
//                         {product.serial_no || "-"}
//                       </td>

//                       <td className="col-spec">
//                         <small>{specLine(product)}</small>

//                         {(product.has_monitor ||
//                           product.has_mouse ||
//                           product.has_keyboard ||
//                           product.has_adapter ||
//                           product.has_cpu) && (
//                           <div className="mt-1">
//                             {product.has_cpu ? (
//                               <span className="unit-id me-1">CPU</span>
//                             ) : null}
//                             {product.has_monitor ? (
//                               <span className="unit-id me-1">Monitor</span>
//                             ) : null}
//                             {product.has_mouse ? (
//                               <span className="unit-id me-1">Mouse</span>
//                             ) : null}
//                             {product.has_keyboard ? (
//                               <span className="unit-id me-1">Keyboard</span>
//                             ) : null}
//                             {product.has_adapter ? (
//                               <span className="unit-id me-1">Adapter</span>
//                             ) : null}
//                           </div>
//                         )}
//                       </td>

//                       <td className="col-purchase">{formatDate(product.purchase_date)}</td>
//                       <td className="col-warranty-exp">{formatDate(product.warranty_expiry_date)}</td>
//                       <td className="col-warranty">{getWarrantyBadge(product.warranty_status)}</td>

//                       <td className="col-price">{money(product.price)}</td>
//                       <td className="col-qty">
//                         <span className="unit-id">{product.qty ?? 0}</span>
//                       </td>
//                       <td className="col-available">
//                         <span className="unit-id">
//                           {product.available_qty ?? product.qty ?? 0}
//                         </span>
//                       </td>
//                       <td className="col-allocated">
//                         <span className="unit-id">{product.allocated_qty ?? 0}</span>
//                       </td>

//                       <td className="col-status">{getStatusBadge(product.status || "ACTIVE")}</td>

//                       <td className="product-history">
//                         <Button
//                           className="unit-btn unit-btn-light"
//                           onClick={() => openHistory(product)}
//                           aria-label={`View allocation history for ${product.name || "product"}`}
//                         >
//                           <i className="fa-solid fa-clock-rotate-left" aria-hidden="true"></i>
//                           History
//                         </Button>
//                       </td>

//                       <td className="col-actions">
//                         <div className="unit-actions">
//                           {canEdit && (
//                             <Button
//                               className="unit-icon-btn unit-edit"
//                               title="Edit"
//                               aria-label={`Edit ${product.name || "product"}`}
//                               onClick={() =>
//                                 setEditingProduct({
//                                   ...product,
//                                   purchase_date: toDateInput(product.purchase_date),
//                                   warranty_date: toDateInput(product.warranty_date),
//                                   warranty_expiry_date: toDateInput(product.warranty_expiry_date),
//                                 })
//                               }
//                             >
//                               <i className="fa-solid fa-pen" aria-hidden="true"></i>
//                             </Button>
//                           )}

//                           {canDelete && (
//                             <Button
//                               className="unit-icon-btn unit-delete"
//                               title="Delete"
//                               aria-label={`Delete ${product.name || "product"}`}
//                               onClick={() => handleDelete(product.id)}
//                             >
//                               <i className="fa-solid fa-trash" aria-hidden="true"></i>
//                             </Button>
//                           )}

//                           <Button
//                             className="unit-icon-btn unit-edit"
//                             title="Print"
//                             aria-label={`Print stock sheet for ${product.name || "product"}`}
//                             onClick={() => printProductSingle(product)}
//                           >
//                             <i className="fa-solid fa-print" aria-hidden="true"></i>
//                           </Button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="16">
//                       <div className="unit-empty">
//                         <div className="unit-empty-icon">
//                           <i className="fa-solid fa-boxes-stacked" aria-hidden="true"></i>
//                         </div>
//                         <h5>No products found</h5>
//                         <p>Try another keyword or add a new product.</p>

//                         {canCreate && (
//                           <Button
//                             className="unit-btn unit-btn-primary"
//                             onClick={openAddModal}
//                           >
//                             <i className="fa-solid fa-plus" aria-hidden="true"></i>
//                             Add Product
//                           </Button>
//                         )}
//                       </div>
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           )}
//         </div>

//         <div className="unit-footer">
//           <div className="unit-count-text">
//             Showing{" "}
//             <strong>{filtered.length === 0 ? 0 : (page - 1) * perPage + 1}</strong>{" "}
//             to <strong>{Math.min(page * perPage, filtered.length)}</strong> of{" "}
//             <strong>{filtered.length}</strong> entries
//           </div>

//           {totalPages > 1 && (
//             <Pagination className="unit-pagination">
//               <Pagination.Prev
//                 disabled={page <= 1}
//                 onClick={() => setPage((prev) => Math.max(1, prev - 1))}
//               />

//               {[...Array(totalPages)].map((_, index) => (
//                 <Pagination.Item
//                   key={index + 1}
//                   active={index + 1 === page}
//                   onClick={() => setPage(index + 1)}
//                 >
//                   {index + 1}
//                 </Pagination.Item>
//               ))}

//               <Pagination.Next
//                 disabled={page >= totalPages}
//                 onClick={() => setPage((prev) => Math.min(totalPages, prev + 1))}
//               />
//             </Pagination>
//           )}
//         </div>
//       </div>

//       <Modal
//         show={!!editingProduct}
//         onHide={() => setEditingProduct(null)}
//         centered
//         scrollable
//         size="lg"
//         className="unit-modal unit-compact-modal"
//         dialogClassName="admin-teal-modal admin-teal-modal-lg"
//         backdropClassName="admin-teal-backdrop"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>
//             {isEditMode ? "Edit Product" : "Add Product"}
//           </Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           {!isEditMode ? (
//             <div className="unit-selected-box">
//               <strong>SKU Auto Generate:</strong> SKU will be generated automatically after save.
//               <div className="unit-sku-note">
//                 Enter multiple serial numbers separated by comma or new line.
//               </div>
//             </div>
//           ) : (
//             <div className="unit-selected-box">
//               <strong>SKU:</strong> {editingProduct?.sku || "-"}
//               <div className="unit-sku-note">
//                 SKU is system generated and cannot be changed.
//               </div>
//             </div>
//           )}

//           <div className="row g-2">
//             <div className="col-md-6">
//               <Form.Label>
//                 Product Name <span className="text-danger">*</span>
//               </Form.Label>
//               <Form.Control
//                 placeholder="Product name"
//                 value={editingProduct?.name || ""}
//                 onChange={(e) => setEditField("name", e.target.value)}
//               />
//             </div>

//             <div className="col-md-3">
//               <Form.Label>Category</Form.Label>
//               <Form.Control
//                 placeholder="Category"
//                 value={editingProduct?.category || ""}
//                 onChange={(e) => setEditField("category", e.target.value)}
//               />
//             </div>

//             <div className="col-md-3">
//               <Form.Label>Brand</Form.Label>
//               <Form.Control
//                 placeholder="Brand"
//                 value={editingProduct?.brand || ""}
//                 onChange={(e) => setEditField("brand", e.target.value)}
//               />
//             </div>

//             <div className="col-md-4">
//               <Form.Label>Model No.</Form.Label>
//               <Form.Control
//                 placeholder="Model No."
//                 value={editingProduct?.model_no || ""}
//                 onChange={(e) => setEditField("model_no", e.target.value)}
//               />
//             </div>

//             <div className="col-md-8">
//               {isEditMode ? (
//                 <>
//                   <Form.Label>Serial No.</Form.Label>
//                   <Form.Control
//                     placeholder="Serial No."
//                     value={editingProduct?.serial_no || ""}
//                     onChange={(e) => setEditField("serial_no", e.target.value)}
//                   />
//                 </>
//               ) : (
//                 <>
//                   <Form.Label>
//                     Serial Numbers <span className="text-danger">*</span>
//                     {serialCount > 0 ? (
//                       <span className="unit-serial-count"> {serialCount} item(s)</span>
//                     ) : null}
//                   </Form.Label>
//                   <Form.Control
//                     as="textarea"
//                     rows={2}
//                     placeholder={"SN001, SN002, SN003\nOr enter one serial number per line"}
//                     value={editingProduct?.serial_numbers || ""}
//                     onChange={(e) => {
//                       const value = e.target.value;
//                       const count = parseSerialList(value).length;

//                       setEditingProduct((prev) => ({
//                         ...(prev || {}),
//                         serial_numbers: value,
//                         qty: count || 1,
//                       }));
//                     }}
//                   />
//                 </>
//               )}
//             </div>

//             <div className="col-md-4">
//               <Form.Label>Purchase Date</Form.Label>
//               <Form.Control
//                 type="date"
//                 value={editingProduct?.purchase_date || ""}
//                 onChange={(e) => {
//                   const value = e.target.value;

//                   setEditingProduct((prev) => ({
//                     ...(prev || {}),
//                     purchase_date: value,
//                     warranty_date: prev?.warranty_date || value,
//                   }));
//                 }}
//               />
//             </div>

//             <div className="col-md-4">
//               <Form.Label>Warranty Start Date</Form.Label>
//               <Form.Control
//                 type="date"
//                 value={editingProduct?.warranty_date || ""}
//                 onChange={(e) => setEditField("warranty_date", e.target.value)}
//               />
//             </div>

//             <div className="col-md-4">
//               <Form.Label>Warranty Expiry Date</Form.Label>
//               <Form.Control
//                 type="date"
//                 value={editingProduct?.warranty_expiry_date || ""}
//                 onChange={(e) => setEditField("warranty_expiry_date", e.target.value)}
//               />
//             </div>

//             <div className="col-md-5">
//               <Form.Label>Processor</Form.Label>
//               <Form.Control
//                 placeholder="Processor"
//                 value={editingProduct?.processor || ""}
//                 onChange={(e) => setEditField("processor", e.target.value)}
//               />
//             </div>

//             <div className="col-md-2">
//               <Form.Label>RAM GB</Form.Label>
//               <Form.Control
//                 type="number"
//                 min="0"
//                 value={editingProduct?.ram_gb ?? ""}
//                 onChange={(e) => setEditField("ram_gb", e.target.value)}
//               />
//             </div>

//             <div className="col-md-2">
//               <Form.Label>SSD GB</Form.Label>
//               <Form.Control
//                 type="number"
//                 min="0"
//                 value={editingProduct?.ssd_gb ?? ""}
//                 onChange={(e) => setEditField("ssd_gb", e.target.value)}
//               />
//             </div>

//             <div className="col-md-3">
//               <Form.Label>HDD GB</Form.Label>
//               <Form.Control
//                 type="number"
//                 min="0"
//                 value={editingProduct?.hdd_gb ?? ""}
//                 onChange={(e) => setEditField("hdd_gb", e.target.value)}
//               />
//             </div>

//             <div className="col-md-4">
//               <Form.Label>Price</Form.Label>
//               <Form.Control
//                 type="number"
//                 min="0"
//                 value={editingProduct?.price ?? ""}
//                 onChange={(e) => setEditField("price", e.target.value)}
//               />
//             </div>

//             <div className="col-md-4">
//               <Form.Label>Qty</Form.Label>
//               <Form.Control
//                 type="number"
//                 min="0"
//                 disabled={!isEditMode && serialCount > 0}
//                 value={editingProduct?.qty ?? ""}
//                 onChange={(e) => setEditField("qty", e.target.value)}
//               />
//             </div>

//             <div className="col-md-4">
//               <Form.Label>Status</Form.Label>
//               <Form.Select
//                 value={editingProduct?.status || "ACTIVE"}
//                 onChange={(e) => setEditField("status", e.target.value)}
//               >
//                 <option value="ACTIVE">ACTIVE</option>
//                 <option value="INACTIVE">INACTIVE</option>
//               </Form.Select>
//             </div>

//             <div className="col-12">
//               <Form.Label>Accessories</Form.Label>

//               <div className="unit-accessory-wrap">
//                 {[
//                   ["has_cpu", "CPU Unit"],
//                   ["has_monitor", "Monitor"],
//                   ["has_mouse", "Mouse"],
//                   ["has_keyboard", "Keyboard"],
//                   ["has_adapter", "Adapter"],
//                 ].map(([key, label]) => (
//                   <Form.Check
//                     key={key}
//                     inline
//                     type="checkbox"
//                     label={label}
//                     checked={!!editingProduct?.[key]}
//                     onChange={(e) => setEditField(key, e.target.checked)}
//                   />
//                 ))}
//               </div>
//             </div>
//           </div>
//         </Modal.Body>

//         <Modal.Footer>
//           <Button
//             className="unit-btn unit-btn-light"
//             onClick={() => setEditingProduct(null)}
//             disabled={saving}
//           >
//             Cancel
//           </Button>

//           <Button
//             className="unit-btn unit-btn-primary"
//             onClick={() => handleSave(editingProduct)}
//             disabled={saving}
//           >
//             {saving
//               ? "Saving..."
//               : !isEditMode && serialCount > 1
//               ? `Save ${serialCount} Products`
//               : "Save Product"}
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       <ProductHistoryModal
//         product={selectedProduct}
//         show={historyOpen}
//         onHide={() => setHistoryOpen(false)}
//       />
//     </div>
//   );
// }


import React, { useEffect, useMemo, useRef, useState } from "react";
import { compactPageItems } from "../../../components/ui/compactPagination";
import api from "../../../api";
import {
  Button,
  Modal,
  Form,
  InputGroup,
  Pagination,
  Spinner,
  Badge,
} from "react-bootstrap";
import ProductHistoryModal from "./ProductHistoryModal";
import AssetValueSummary from "../../../components/shared/AssetValueSummary";
import { BLANK_DISPOSAL, DISPOSAL_METHODS, disposalPayload, validateDisposalForm } from "../../../utils/assetDisposal";
import { toDateOnlyString } from "../../../utils/dateOnly";
import { LIFECYCLE_FILTER_CODES, endLifeFormState, lifecycleLabel, lifecycleTone } from "../../../utils/assetLifecycle";
import { usePermissions } from "../../../context/PermissionContext";
import "./InventoryProductList.css";

// ---------- CSV helpers ----------
const toCsv = (rows) => {
  if (!rows?.length) return "";

  const headers = Object.keys(rows[0]);

  const escape = (value) =>
    value == null
      ? ""
      : `${value}`.includes(",") ||
        `${value}`.includes('"') ||
        `${value}`.includes("\n")
      ? `"${`${value}`.replace(/"/g, '""')}"`
      : `${value}`;

  return [
    headers.join(","),
    ...rows.map((row) => headers.map((header) => escape(row[header])).join(",")),
  ].join("\n");
};

const parseCsv = async (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onerror = reject;

    reader.onload = () => {
      try {
        const text = reader.result;
        const [headerLine, ...dataLines] = text.split(/\r?\n/).filter(Boolean);
        const headers = headerLine.split(",").map((h) => h.trim());

        const rows = dataLines.map((line) => {
          const parts = [];
          let current = "";
          let inQuote = false;

          for (let i = 0; i < line.length; i++) {
            const char = line[i];

            if (char === '"' && line[i + 1] === '"' && inQuote) {
              current += '"';
              i++;
            } else if (char === '"') {
              inQuote = !inQuote;
            } else if (char === "," && !inQuote) {
              parts.push(current);
              current = "";
            } else {
              current += char;
            }
          }

          parts.push(current);

          const obj = {};
          headers.forEach((header, index) => {
            obj[header] = parts[index] ?? "";
          });

          return obj;
        });

        resolve({ headers, rows });
      } catch (error) {
        reject(error);
      }
    };

    reader.readAsText(file);
  });

const blankProduct = {
  name: "",
  category: "",
  brand: "",
  model_no: "",
  serial_no: "",
  serial_numbers: "",
  processor: "",
  ram_gb: "",
  ssd_gb: "",
  hdd_gb: "",
  purchase_date: "",
  warranty_date: "",
  warranty_expiry_date: "",
  price: "",
  qty: 1,
  status: "ACTIVE",
  has_cpu: false,
  has_monitor: false,
  has_mouse: false,
  has_keyboard: false,
  has_adapter: false,
  useful_life_value: "",
  useful_life_unit: "YEARS",
};

const DISCARD_REASONS = [
  ["END_OF_USEFUL_LIFE", "End of Useful Life"],
  ["DAMAGED", "Damaged"],
  ["BEYOND_REPAIR", "Beyond Repair"],
  ["OBSOLETE", "Obsolete"],
  ["UNSERVICEABLE", "Unserviceable"],
  ["LOST", "Lost"],
  ["OTHER", "Other"],
];

const LIFE_REVIEW_CONDITIONS = ["WORKING", "REPAIRABLE", "POOR", "OTHER"];


const todayInputDate = () => new Date().toISOString().slice(0, 10);

export default function InventoryProductList() {
  const { can } = usePermissions();
  const canCreate = can("products", "create");
  const canEdit = can("products", "edit");
  const canDelete = can("products", "delete");
  const canDiscard = can("products", "discard");

  const [products, setProducts] = useState([]);
  const [editingProduct, setEditingProduct] = useState(null);

  const [query, setQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("ALL");
  const [lifecycleFilter, setLifecycleFilter] = useState("ALL");

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const fileRef = useRef(null);

  const [historyOpen, setHistoryOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const [discardTarget, setDiscardTarget] = useState(null);
  const [discardForm, setDiscardForm] = useState({ discard_date: todayInputDate(), reason: "", remarks: "", ...BLANK_DISPOSAL });
  const [discarding, setDiscarding] = useState(false);

  const [reviewTarget, setReviewTarget] = useState(null);
  const [reviewForm, setReviewForm] = useState({ condition: "", decision: "CONTINUE_IN_USE", revised_expected_end_date: "", remarks: "" });
  const [reviewing, setReviewing] = useState(false);

  useEffect(() => {
    fetchProducts();
  }, []);

  useEffect(() => {
    setPage(1);
  }, [query, statusFilter, perPage]);

  const fetchProducts = async () => {
    try {
      setLoading(true);
      const res = await api.get(`/products`);
      setProducts(Array.isArray(res.data) ? res.data : []);
      setPage(1);
    } catch (error) {
      console.error("Error fetching products:", error);
      alert("Failed to fetch products");
    } finally {
      setLoading(false);
    }
  };

  const openHistory = (product) => {
    setSelectedProduct(product);
    setHistoryOpen(true);
  };

  const openAddModal = () => {
    setEditingProduct({ ...blankProduct });
  };

  const setEditField = (key, value) => {
    setEditingProduct((prev) => ({
      ...(prev || {}),
      [key]: value,
    }));
  };

  const parseSerialList = (text) => {
    return String(text || "")
      .split(/[\n,]+/)
      .map((v) => v.trim())
      .filter(Boolean);
  };

  // Every date this page shows is a calendar day. Read it as Y/M/D (a
  // timestamp as its IST day, utils/dateOnly.js), never through the
  // browser's own timezone, which moved it back a day west of UTC.
  const formatDate = (value) => {
    const s = toDateOnlyString(value);
    if (!s) return "-";
    const [y, m, d] = s.split("-").map(Number);

    return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      timeZone: "UTC",
    });
  };

  const toDateInput = (value) => toDateOnlyString(value) || "";

  const getWarrantyBadge = (status) => {
    const value = String(status || "NO_WARRANTY").toUpperCase();

    if (value === "IN_WARRANTY") {
      return (
        <Badge className="unit-warranty unit-warranty-active">
          In Warranty
        </Badge>
      );
    }

    if (value === "EXPIRED") {
      return (
        <Badge className="unit-warranty unit-warranty-expired">
          Expired
        </Badge>
      );
    }

    return (
      <Badge className="unit-warranty unit-warranty-none">
        No Warranty
      </Badge>
    );
  };

  // Phase 57: hard delete is Admin-only data-cleanup for a product with ZERO
  // history (backend blocks it outright if the product was ever allocated,
  // invoiced, or reserved -- see controllers/productController.js#remove).
  // It is deliberately NOT the standard lifecycle action -- Manual Discard
  // (submitDiscard, above) is. A reason is required and is logged server-side
  // alongside who deleted it (product_deletion_audit).
  const handleDelete = async (id) => {
    if (
      !window.confirm(
        "Permanently delete this product?\n\nThis cannot be undone. This is only allowed for products with no allocation, invoice, or reservation history -- use Discard for anything that has been in use."
      )
    ) {
      return;
    }

    const reason = window.prompt("Reason for permanently deleting this product (required):", "");
    if (reason === null) return;
    if (!reason.trim()) {
      alert("A reason is required to permanently delete a product.");
      return;
    }

    try {
      await api.delete(`/products/${id}`, { data: { reason: reason.trim() } });
      await fetchProducts();
      alert("Product permanently deleted");
    } catch (error) {
      console.error("Error deleting product:", error);
      alert(error?.response?.data?.message || error?.response?.data?.error || "Failed to delete product");
    }
  };

  // ---- Manual Discard (task §9/§10/§11/§12) --------------------------------
  // Discard is ALWAYS an explicit user action, never triggered by expected
  // life expiry -- this modal is the only place PUT /products/:id/discard is
  // ever called from.
  const openDiscardModal = (product) => {
    setDiscardTarget(product);
    setDiscardForm({ discard_date: todayInputDate(), reason: "", remarks: "", ...BLANK_DISPOSAL });
  };

  const submitDiscard = async () => {
    if (!discardTarget) return;

    if (!discardForm.discard_date) {
      alert("Discard Date is required");
      return;
    }
    if (!discardForm.reason) {
      alert("Reason is required");
      return;
    }
    if (discardForm.reason === "OTHER" && !discardForm.remarks.trim()) {
      alert('Remarks are required when Reason is "Other"');
      return;
    }
    const disposalError = validateDisposalForm(discardForm, { purchaseDate: discardTarget.purchase_date });
    if (disposalError) {
      alert(disposalError);
      return;
    }

    try {
      setDiscarding(true);
      await api.put(`/products/${discardTarget.id}/discard`, {
        discard_date: discardForm.discard_date,
        reason: discardForm.reason,
        remarks: discardForm.remarks || null,
        ...disposalPayload(discardForm),
      });
      alert("Product discarded successfully");
      setDiscardTarget(null);
      await fetchProducts();
    } catch (error) {
      console.error("Error discarding product:", error);
      // PUT /products/:id/discard (controllers/productController.js#discard)
      // uses the ApiError shape ({success:false, code, message}), unlike
      // this file's older product endpoints (delete/save/import), which
      // return {error: "..."} -- reading `.error` here always came back
      // undefined, silently swallowing the real reason (e.g. "This product
      // is currently allocated. Return all allocated quantity before
      // discarding it.") and showing only a generic fallback instead.
      alert(error?.response?.data?.message || error?.response?.data?.error || "Failed to discard product");
    } finally {
      setDiscarding(false);
    }
  };

  // ---- Life Review (task §7/§8) -- lightweight acknowledgement only, never
  // required to allocate the product (it's already allocatable). ----------
  const openReviewModal = (product) => {
    setReviewTarget(product);
    setReviewForm({
      condition: product.life_review_condition || "",
      decision: "CONTINUE_IN_USE",
      revised_expected_end_date: "",
      remarks: "",
    });
  };

  const submitReview = async () => {
    if (!reviewTarget) return;

    if (!reviewForm.condition) {
      alert("Condition is required");
      return;
    }

    try {
      setReviewing(true);
      await api.put(`/products/${reviewTarget.id}/life-review`, {
        condition: reviewForm.condition,
        decision: reviewForm.decision,
        revised_expected_end_date: reviewForm.revised_expected_end_date || null,
        remarks: reviewForm.remarks || null,
      });
      alert("Product life review saved");
      setReviewTarget(null);
      await fetchProducts();
    } catch (error) {
      console.error("Error saving life review:", error);
      alert(error?.response?.data?.error || "Failed to save life review");
    } finally {
      setReviewing(false);
    }
  };

  const getLifecycleBadge = (lifecycle) => {
    const toneClass =
      { ok: "unit-warranty-active", bad: "unit-warranty-expired" }[lifecycleTone(lifecycle)] ||
      "unit-warranty-none";

    return (
      <Badge className={`unit-warranty ${toneClass}`}>
        {lifecycleLabel(lifecycle)}
      </Badge>
    );
  };

  const handleSave = async (product) => {
    if (!product?.name?.trim()) {
      alert("Product name is required");
      return;
    }

    const isEdit = !!product.id;
    const serialList = parseSerialList(product.serial_numbers);

    if (!isEdit && !serialList.length) {
      alert("Please enter at least one serial number");
      return;
    }

    // Product Life is optional (historical products), but when given must be
    // a positive whole number -- mirrors validators/productLifecycleValidator.js's
    // isValidUsefulLife (server is still the source of truth; this is UX only).
    const usefulLifeValueRaw = product.useful_life_value;
    if (usefulLifeValueRaw !== "" && usefulLifeValueRaw != null) {
      const n = Number(usefulLifeValueRaw);
      if (!Number.isInteger(n) || n <= 0) {
        alert("Product Life must be a positive whole number.");
        return;
      }
    }

    try {
      setSaving(true);

      const usefulLifeConfigured = usefulLifeValueRaw !== "" && usefulLifeValueRaw != null;

      const payload = {
        name: product.name?.trim(),
        category: product.category || "",
        brand: product.brand || "",
        model_no: product.model_no || "",

        serial_no: isEdit ? product.serial_no || "" : undefined,
        serial_numbers: !isEdit ? serialList : undefined,

        processor: product.processor || "",
        ram_gb:
          product.ram_gb === "" || product.ram_gb == null
            ? null
            : Number(product.ram_gb),
        ssd_gb:
          product.ssd_gb === "" || product.ssd_gb == null
            ? null
            : Number(product.ssd_gb),
        hdd_gb:
          product.hdd_gb === "" || product.hdd_gb == null
            ? null
            : Number(product.hdd_gb),

        price: Number(product.price || 0),
        qty: isEdit ? Number(product.qty || 0) : serialList.length || Number(product.qty || 1),

        purchase_date: product.purchase_date || null,
        warranty_date: product.warranty_date || product.purchase_date || null,
        warranty_expiry_date: product.warranty_expiry_date || null,

        has_cpu: product.has_cpu ? 1 : 0,
        has_monitor: product.has_monitor ? 1 : 0,
        has_mouse: product.has_mouse ? 1 : 0,
        has_keyboard: product.has_keyboard ? 1 : 0,
        has_adapter: product.has_adapter ? 1 : 0,
        status: product.status || "ACTIVE",

        // Advisory-only expected life, separate from Warranty (task rule).
        // Both fields null together when left blank -- never fabricated for
        // a historical product.
        useful_life_value: usefulLifeConfigured ? Number(usefulLifeValueRaw) : null,
        useful_life_unit: usefulLifeConfigured ? product.useful_life_unit || "YEARS" : null,
      };

      if (isEdit) {
        await api.put(`/products/${product.id}`, payload);
        alert("Product updated successfully");
      } else {
        await api.post(`/products`, payload);
        alert(
          serialList.length > 1
            ? `${serialList.length} products added successfully`
            : "Product added successfully"
        );
      }

      setEditingProduct(null);
      fetchProducts();
    } catch (error) {
      console.error("Error saving product:", error);
      alert(error?.response?.data?.error || "Failed to save product");
    } finally {
      setSaving(false);
    }
  };

  const specLine = (product) => {
    if (!product) return "-";

    const ram = product.ram_gb ? `${product.ram_gb}GB` : "-";
    const storage = product.ssd_gb
      ? `${product.ssd_gb}GB SSD`
      : product.hdd_gb
      ? `${product.hdd_gb}GB HDD`
      : "-";

    return `${product.processor || "-"} / ${ram} / ${storage}`;
  };

  const money = (value) => {
    const number = Number(value ?? 0);
    return Number.isFinite(number) ? `₹${number.toFixed(2)}` : "-";
  };

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();

    let data = [...products];

    // "Discarded" is an Operational Status choice, but deliberately NOT part
    // of the products.status ACTIVE/INACTIVE enum (task §13/§14) -- filtered
    // on is_discarded separately here.
    if (statusFilter === "DISCARDED") {
      data = data.filter((product) => product.is_discarded);
    } else if (statusFilter !== "ALL") {
      data = data.filter((product) => product.status === statusFilter && !product.is_discarded);
    }

    if (lifecycleFilter !== "ALL") {
      data = data.filter((product) => (product.lifecycle || "NOT_CONFIGURED") === lifecycleFilter);
    }

    if (q) {
      const fields = [
        "sku",
        "name",
        "category",
        "brand",
        "model_no",
        "serial_no",
        "processor",
        "warranty_status",
        "purchase_date",
        "warranty_expiry_date",
      ];

      data = data.filter((product) =>
        fields
          .map((field) => product[field])
          .filter(Boolean)
          .some((value) => String(value).toLowerCase().includes(q))
      );
    }

    return data;
  }, [products, query, statusFilter, lifecycleFilter]);

  const stats = useMemo(() => {
    return {
      total: products.length,
      active: products.filter((p) => p.status !== "INACTIVE").length,
      inactive: products.filter((p) => p.status === "INACTIVE").length,
      inWarranty: products.filter((p) => p.warranty_status === "IN_WARRANTY").length,
      expiredWarranty: products.filter((p) => p.warranty_status === "EXPIRED").length,
      totalQty: products.reduce((sum, p) => sum + Number(p.qty || 0), 0),
      totalValue: products.reduce(
        (sum, p) => sum + Number(p.qty || 0) * Number(p.price || 0),
        0
      ),
    };
  }, [products]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / perPage));

  const pageData = useMemo(() => {
    const start = (page - 1) * perPage;
    return filtered.slice(start, start + perPage);
  }, [filtered, page, perPage]);

  const exportCsv = (onlyPage = false) => {
    const rows = onlyPage ? pageData : filtered;

    if (!rows.length) {
      alert("No products available to export");
      return;
    }

    const formattedRows = rows.map((product) => ({
      id: product.id,
      sku: product.sku,
      name: product.name,
      category: product.category,
      brand: product.brand,
      model_no: product.model_no,
      serial_no: product.serial_no,
      processor: product.processor,
      ram_gb: product.ram_gb,
      ssd_gb: product.ssd_gb,
      hdd_gb: product.hdd_gb,
      purchase_date: product.purchase_date,
      warranty_date: product.warranty_date,
      warranty_expiry_date: product.warranty_expiry_date,
      warranty_status: product.warranty_status,
      has_cpu: product.has_cpu ? 1 : 0,
      has_monitor: product.has_monitor ? 1 : 0,
      has_mouse: product.has_mouse ? 1 : 0,
      has_keyboard: product.has_keyboard ? 1 : 0,
      has_adapter: product.has_adapter ? 1 : 0,
      price: product.price,
      qty: product.qty,
      status: product.status,
    }));

    const csv = toCsv(formattedRows);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `products_${onlyPage ? `page${page}` : "all"}.csv`;
    link.click();

    URL.revokeObjectURL(link.href);
  };

  const onImportClick = () => fileRef.current?.click();

  const toNum = (value, def = 0) => {
    const number = Number(value);
    return Number.isFinite(number) ? number : def;
  };

  const onImportFile = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    try {
      const { rows } = await parseCsv(file);

      const cleaned = rows
        .map((row) => ({
          name: row.name || row["Product Name"] || row.product_name || "",
          category: row.category || row.Category || "",
          brand: row.brand || row.Brand || "",
          model_no: row.model_no || row.Model || row["Model No"] || "",
          serial_no: row.serial_no || row.Serial || row["Serial No"] || "",
          serial_numbers:
            row.serial_numbers ||
            row["Serial Numbers"] ||
            row.serial_no ||
            row.Serial ||
            row["Serial No"] ||
            "",
          processor: row.processor || row.CPU || "",
          ram_gb: toNum(row.ram_gb ?? row.RAM),
          ssd_gb: toNum(row.ssd_gb ?? row.SSD),
          hdd_gb: toNum(row.hdd_gb ?? row.HDD),
          purchase_date: row.purchase_date || row["Purchase Date"] || "",
          warranty_date: row.warranty_date || row["Warranty Date"] || "",
          warranty_expiry_date:
            row.warranty_expiry_date ||
            row["Warranty Expiry Date"] ||
            row["Warranty Expiry"] ||
            "",
          has_cpu: toNum(row.has_cpu ?? row.CPU_Unit) ? 1 : 0,
          has_monitor: toNum(row.has_monitor ?? row.Monitor) ? 1 : 0,
          has_mouse: toNum(row.has_mouse ?? row.Mouse) ? 1 : 0,
          has_keyboard: toNum(row.has_keyboard ?? row.Keyboard) ? 1 : 0,
          has_adapter: toNum(row.has_adapter ?? row.Adapter) ? 1 : 0,
          price: toNum(row.price ?? row.Price),
          qty: toNum(row.qty ?? row.Qty, 1),
          status:
            (row.status || "ACTIVE").toUpperCase() === "INACTIVE"
              ? "INACTIVE"
              : "ACTIVE",
        }))
        .filter((item) => item.name);

      if (!cleaned.length) {
        alert("No valid rows found in CSV. Product name is required.");
        return;
      }

      await api.post(`/products/import`, {
        rows: cleaned,
      });

      await fetchProducts();
      alert(`Imported ${cleaned.length} CSV row(s). SKU generated by backend.`);
    } catch (error) {
      console.error("Import error:", error);
      alert(error?.response?.data?.error || "Import failed. Check console for details.");
    } finally {
      event.target.value = "";
    }
  };

  const orgInfo = {
    name: "Jaipuria Schools",
    address: "Sector-XX, City, State - 000000",
    phone: "+91-00000-00000",
    email: "info@jaipuria.edu",
  };

  const esc = (value) =>
    String(value ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");

  const pad2 = (number) => String(number).padStart(2, "0");

  const formatDMY = (date) => {
    const dt = date instanceof Date ? date : new Date(date);
    if (Number.isNaN(dt.getTime())) return "-";
    return `${pad2(dt.getDate())}-${pad2(dt.getMonth() + 1)}-${dt.getFullYear()}`;
  };

  const buildProductSheetHTML = (rows, title = "Product Stock Sheet") => {
    const today = formatDMY(new Date());
    const isSingle = rows.length === 1;

    const bodyRows = rows
      .map(
        (row, index) => `
        <tr>
          <td>${index + 1}</td>
          <td>${esc(row.sku ?? "-")}</td>
          <td>${esc(row.name ?? "-")}</td>
          <td>${esc(row.model_no ?? "-")}</td>
          <td>${esc(row.serial_no ?? "-")}</td>
          <td>${esc(row.processor ?? "-")} / ${row.ram_gb || "-"}GB / ${
          row.ssd_gb
            ? `${row.ssd_gb}GB SSD`
            : row.hdd_gb
            ? `${row.hdd_gb}GB HDD`
            : "-"
        }</td>
          <td>${formatDMY(row.purchase_date)}</td>
          <td>${formatDMY(row.warranty_expiry_date)}</td>
          <td>${esc(row.warranty_status ?? "-")}</td>
          <td class="num">${money(row.price)}</td>
          <td class="num">${Number(row.qty ?? 0)}</td>
          <td>${esc(row.status ?? "-")}</td>
        </tr>`
      )
      .join("");

    const singleMeta = isSingle
      ? `
      <table class="meta">
        <tr>
          <td><b>SKU:</b> ${esc(rows[0].sku ?? "-")}</td>
          <td><b>Name:</b> ${esc(rows[0].name ?? "-")}</td>
          <td><b>Brand:</b> ${esc(rows[0].brand ?? "-")}</td>
        </tr>
      </table>`
      : "";

    return `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8"/>
<title>${esc(title)}</title>
<style>
  @page { size: A4 landscape; margin: 12mm; }
  html, body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  body { font-family: Arial, sans-serif; color: #111827; }
  .head { display:flex; justify-content:space-between; align-items:flex-start; border-bottom:2px solid #e5e7eb; padding-bottom:10px; margin-bottom:10px; }
  .brand { font-weight:800; font-size:20px; line-height:1.1; }
  .muted { color:#6b7280; font-size:12px; }
  .title { text-align:center; margin:8px 0 12px; font-size:18px; font-weight:800; }
  .meta { width:100%; border:1px solid #e5e7eb; border-radius:8px; padding:8px; font-size:12px; margin-bottom:10px; border-collapse:separate; border-spacing:0; }
  .meta td { padding:4px 6px; vertical-align:top; }
  .table { width:100%; border-collapse:collapse; margin-top:8px; font-size:10px; }
  .table th, .table td { border:1px solid #e5e7eb; padding:5px 6px; }
  .table thead th { background:#f9fafb; text-transform:uppercase; letter-spacing:.02em; font-size:9px; color:#6b7280; }
  .num { text-align:right; font-variant-numeric: tabular-nums; }
  .sign-grid { display:grid; grid-template-columns:1fr 1fr 1fr; gap:14px; margin-top:18px; }
  .sign-card { border:1px dashed #cbd5e1; border-radius:8px; padding:10px; }
  .sign-line { border-top:1px solid #94a3b8; margin-top:28px; }
  .label { font-size:11px; color:#6b7280; }
  .foot { margin-top:14px; font-size:11px; color:#6b7280; }
</style>
</head>
<body>
  <div class="head">
    <div>
      <div class="brand">${esc(orgInfo.name)}</div>
      <div class="muted">${esc(orgInfo.address)}</div>
      <div class="muted">${esc(orgInfo.phone)} | ${esc(orgInfo.email)}</div>
    </div>
    <div class="muted" style="text-align:right">
      <div>Date: <b>${esc(today)}</b></div>
      <div>Doc #: ____________</div>
    </div>
  </div>

  <div class="title">${esc(title)}</div>

  <table class="meta">
    <tr>
      <td><b>Total Items:</b> ${rows.length}</td>
      <td><b>Prepared By:</b> ____________________</td>
      <td><b>Checked By:</b> ____________________</td>
    </tr>
  </table>

  ${singleMeta}

  <table class="table">
    <thead>
      <tr>
        <th>#</th>
        <th>SKU</th>
        <th>Product</th>
        <th>Model</th>
        <th>Serial</th>
        <th>Spec</th>
        <th>Purchase</th>
        <th>Warranty Exp.</th>
        <th>Warranty</th>
        <th>Price</th>
        <th>Qty</th>
        <th>Status</th>
      </tr>
    </thead>
    <tbody>${bodyRows}</tbody>
  </table>

  <div class="sign-grid">
    <div class="sign-card">
      <div><b>Recieved By</b></div>
      <div class="label">Name & Signature</div>
      <div class="sign-line"></div>
    </div>
    <div class="sign-card">
      <div><b>Received By</b></div>
      <div class="label">Name & Signature</div>
      <div class="sign-line"></div>
    </div>
    <div class="sign-card">
      <div><b>Verified By</b></div>
      <div class="label">Name & Signature</div>
      <div class="sign-line"></div>
    </div>
  </div>

  <div class="foot">
    <b>Note:</b> Physical counts should be verified against system records. Report discrepancies within 24 hours.
  </div>
</body>
</html>`;
  };

  const printProductRows = (rows, title) => {
    const printWindow = window.open("", "_blank", "width=900,height=1000");

    if (!printWindow) {
      alert("Popup blocked. Please allow popups to print.");
      return;
    }

    const html = buildProductSheetHTML(rows ?? [], title);

    printWindow.document.open();
    printWindow.document.write(html);
    printWindow.document.close();

    printWindow.onload = () => {
      try {
        printWindow.focus();
      } catch {}
      printWindow.print();
    };
  };

  const printProductSingle = (row) => {
    if (!row) return;
    printProductRows([row], "Product Stock Sheet — Single");
  };

  const clearFilters = () => {
    setQuery("");
    setStatusFilter("ALL");
    setLifecycleFilter("ALL");
    setPage(1);
  };

  // Discarded is a permanent lifecycle retirement, NOT the same as the
  // reversible Active<->Inactive operational status -- it must never share
  // Inactive's label or color (both previously rendered as the same red
  // "unit-status-inactive" badge, making a scrapped product visually
  // indistinguishable from one that's merely temporarily disabled).
  const getStatusBadge = (status, isDiscarded) => {
    if (isDiscarded) {
      return <Badge className="unit-status unit-status-discarded">Discarded</Badge>;
    }

    if (status === "INACTIVE") {
      return <Badge className="unit-status unit-status-inactive">Inactive</Badge>;
    }

    return <Badge className="unit-status unit-status-active">Active</Badge>;
  };

  const serialCount = parseSerialList(editingProduct?.serial_numbers).length;
  const isEditMode = !!editingProduct?.id;

  return (
    <div className="unit-page inventory-product-theme">
      <div className="inventory-heading-box">
        <div className="inventory-heading-content">
          <div className="inventory-heading-icon">
            <i className="fa-solid fa-boxes-stacked" aria-hidden="true"></i>
          </div>

          <div>
            <div className="unit-page-label">Inventory</div>
            <h2>Assets List</h2>
            <p>
              Manage inventory products, stock quantity, specifications,
              warranty details and CSV import/export.
            </p>
          </div>
        </div>

        <div className="unit-header-actions">
          <Button className="unit-btn unit-btn-light" onClick={fetchProducts}>
            <i className="fa-solid fa-rotate" aria-hidden="true"></i>
            Refresh
          </Button>

          <Button className="unit-btn unit-btn-light" onClick={onImportClick}>
            <i className="fa-solid fa-file-import" aria-hidden="true"></i>
            Import CSV
          </Button>

          {canCreate && (
            <Button className="unit-btn unit-btn-primary" onClick={openAddModal}>
              <i className="fa-solid fa-plus" aria-hidden="true"></i>
              Add Product
            </Button>
          )}
        </div>
      </div>

      <input
        ref={fileRef}
        type="file"
        accept=".csv"
        hidden
        onChange={onImportFile}
      />

      <div className="unit-stats-row unit-top-stats">
        <div className="unit-stat-card inventory-stat-blue">
          <div className="inventory-stat-content">
            <div className="inventory-stat-copy">
              <span>Total Products</span>
              <strong>{stats.total}</strong>
            </div>
            <div className="inventory-stat-icon">
              <i className="fa-solid fa-boxes-stacked" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card inventory-stat-green">
          <div className="inventory-stat-content">
            <div className="inventory-stat-copy">
              <span>Active</span>
              <strong>{stats.active}</strong>
            </div>
            <div className="inventory-stat-icon">
              <i className="fa-solid fa-circle-check" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card inventory-stat-red">
          <div className="inventory-stat-content">
            <div className="inventory-stat-copy">
              <span>Inactive</span>
              <strong>{stats.inactive}</strong>
            </div>
            <div className="inventory-stat-icon">
              <i className="fa-solid fa-circle-xmark" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card inventory-stat-orange">
          <div className="inventory-stat-content">
            <div className="inventory-stat-copy">
              <span>In Warranty</span>
              <strong>{stats.inWarranty}</strong>
            </div>
            <div className="inventory-stat-icon">
              <i className="fa-solid fa-shield-halved" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card inventory-stat-purple">
          <div className="inventory-stat-content">
            <div className="inventory-stat-copy">
              <span>Total Value</span>
              <strong>{money(stats.totalValue)}</strong>
            </div>
            <div className="inventory-stat-icon">
              <i className="fa-solid fa-indian-rupee-sign" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </div>

      <AssetValueSummary refreshKey={products} />

      <div className="unit-card">
        <div className="unit-toolbar">
          <div className="inventory-section-title">
            <div className="inventory-section-icon">
              <i className="fa-solid fa-table-list" aria-hidden="true"></i>
            </div>
            <div>
              <h5>Product Inventory</h5>
              <p>Search, filter, add, edit, delete, print and view allocation history.</p>
            </div>
          </div>

          <div className="unit-toolbar-actions">
            <InputGroup className="unit-search">
              <InputGroup.Text aria-hidden="true">
                <i className="fa-solid fa-magnifying-glass"></i>
              </InputGroup.Text>

              <Form.Control
                placeholder="Search SKU, name, model, serial, warranty..."
                aria-label="Search SKU, name, model, serial, warranty"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
              />

              {query && (
                <Button className="unit-clear-btn" onClick={() => setQuery("")} title="Clear search">
                  <i className="fa-solid fa-xmark" aria-hidden="true"></i>
                </Button>
              )}
            </InputGroup>

            <Form.Select
              className="unit-page-size"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              aria-label="Operational Status"
            >
              <option value="ALL">All Status</option>
              <option value="ACTIVE">Active</option>
              <option value="INACTIVE">Inactive</option>
              <option value="DISCARDED">Discarded</option>
            </Form.Select>

            <Form.Select
              className="unit-page-size"
              value={lifecycleFilter}
              onChange={(e) => setLifecycleFilter(e.target.value)}
              aria-label="Life Status"
            >
              <option value="ALL">All Life Status</option>
              {LIFECYCLE_FILTER_CODES.map((code) => (
                <option key={code} value={code}>{lifecycleLabel(code)}</option>
              ))}
            </Form.Select>

            <Form.Select
              className="unit-page-size"
              value={perPage}
              onChange={(e) => setPerPage(Number(e.target.value))}
            >
              <option value={10}>10 rows</option>
              <option value={25}>25 rows</option>
              <option value={50}>50 rows</option>
              <option value={100}>100 rows</option>
            </Form.Select>

            <Button className="unit-btn unit-btn-light" onClick={() => exportCsv(true)}>
              <i className="fa-solid fa-file-csv" aria-hidden="true"></i>
              Export Page
            </Button>

            <Button className="unit-btn unit-btn-light" onClick={() => exportCsv(false)}>
              <i className="fa-solid fa-file-csv" aria-hidden="true"></i>
              Export All
            </Button>

            <Button
              className="unit-btn unit-btn-light"
              onClick={() => printProductRows(filtered, "Product Stock Sheet — All")}
            >
              <i className="fa-solid fa-print" aria-hidden="true"></i>
              Print All
            </Button>

            {(query || statusFilter !== "ALL" || lifecycleFilter !== "ALL") && (
              <Button className="unit-btn unit-btn-light" onClick={clearFilters}>
                <i className="fa-solid fa-rotate-left" aria-hidden="true"></i>
                Reset
              </Button>
            )}
          </div>
        </div>

        <div className="unit-table-wrapper">
          {loading ? (
            <div className="unit-loader">
              <Spinner animation="border" />
              <p>Loading products...</p>
            </div>
          ) : (
            <table className="table unit-table product-inventory-table">
              <thead>
                <tr>
                  <th className="col-sno">S.No.</th>
                  <th className="col-product">Product</th>
                  <th className="col-category">Category</th>
                  <th className="col-brand">Brand</th>
                  <th className="col-model">Model</th>
                  <th className="col-serial">Serial</th>
                  <th className="col-spec">Spec</th>
                  <th className="col-purchase">Purchase</th>
                  <th className="col-warranty-exp">Warranty Exp.</th>
                  <th className="col-warranty">Warranty</th>
                  <th className="col-price">Price</th>
                  <th className="col-qty">Total Qty</th>
                  <th className="col-available">Available</th>
                  <th className="col-allocated">Allocated</th>
                  <th className="col-life">Life</th>
                  <th className="col-status">Status</th>
                  <th className="product-history">History</th>
                  <th className="col-actions text-center">Actions</th>
                </tr>
              </thead>

              <tbody>
                {pageData.length > 0 ? (
                  pageData.map((product, index) => (
                    <tr key={product.id}>
                      <td className="col-sno">
                        <span className="unit-id">
                          #{(page - 1) * perPage + index + 1}
                        </span>
                      </td>

                      <td className="col-product">
                        <div className="unit-name-box">
                          <div className="unit-letter">
                            {product.name?.charAt(0)?.toUpperCase() || "P"}
                          </div>

                          <div className="product-text">
                            <strong title={product.name || "-"}>{product.name}</strong>
                            <small title={product.sku || "-"}>SKU: {product.sku || "-"}</small>
                          </div>
                        </div>
                      </td>

                      <td className="col-category">{product.category || "-"}</td>
                      <td className="col-brand" title={product.brand || "-"}>{product.brand || "-"}</td>
                      <td className="col-model" title={product.model_no || "-"}>
                        {product.model_no || "-"}
                      </td>
                      <td className="col-serial" title={product.serial_no || "-"}>
                        {product.serial_no || "-"}
                      </td>

                      <td className="col-spec">
                        <small>{specLine(product)}</small>

                        {(product.has_monitor ||
                          product.has_mouse ||
                          product.has_keyboard ||
                          product.has_adapter ||
                          product.has_cpu) && (
                          <div className="mt-1">
                            {product.has_cpu ? (
                              <span className="unit-id me-1">CPU</span>
                            ) : null}
                            {product.has_monitor ? (
                              <span className="unit-id me-1">Monitor</span>
                            ) : null}
                            {product.has_mouse ? (
                              <span className="unit-id me-1">Mouse</span>
                            ) : null}
                            {product.has_keyboard ? (
                              <span className="unit-id me-1">Keyboard</span>
                            ) : null}
                            {product.has_adapter ? (
                              <span className="unit-id me-1">Adapter</span>
                            ) : null}
                          </div>
                        )}
                      </td>

                      <td className="col-purchase">{formatDate(product.purchase_date)}</td>
                      <td className="col-warranty-exp">{formatDate(product.warranty_expiry_date)}</td>
                      <td className="col-warranty">{getWarrantyBadge(product.warranty_status)}</td>

                      <td className="col-price">{money(product.price)}</td>
                      <td className="col-qty">
                        <span className="unit-id">{product.qty ?? 0}</span>
                      </td>
                      <td className="col-available">
                        <span className="unit-id">
                          {product.available_qty ?? product.qty ?? 0}
                        </span>
                      </td>
                      <td className="col-allocated">
                        <span className="unit-id">{product.allocated_qty ?? 0}</span>
                      </td>

                      <td className="col-life">
                        {product.useful_life_label ? (
                          <>
                            <div>{product.useful_life_label}</div>
                            <small className="text-muted d-block">{product.remaining_life_label || "-"}</small>
                            {getLifecycleBadge(product.lifecycle)}
                          </>
                        ) : (
                          <span className="text-muted">—</span>
                        )}
                      </td>

                      <td className="col-status">{getStatusBadge(product.status || "ACTIVE", product.is_discarded)}</td>

                      <td className="product-history">
                        <Button
                          className="unit-btn unit-btn-light"
                          onClick={() => openHistory(product)}
                          aria-label={`View allocation history for ${product.name || "product"}`}
                        >
                          <i className="fa-solid fa-clock-rotate-left" aria-hidden="true"></i>
                          History
                        </Button>
                      </td>

                      <td className="col-actions">
                        <div className="unit-actions">
                          {canEdit && (
                            <Button
                              className="unit-icon-btn unit-edit"
                              title={
                                product.is_discarded
                                  ? "This product has been discarded and is retained as a historical record."
                                  : "Edit"
                              }
                              aria-label={
                                product.is_discarded
                                  ? `${product.name || "Product"} has been discarded and cannot be edited`
                                  : `Edit ${product.name || "product"}`
                              }
                              disabled={!!product.is_discarded}
                              // Discarded products are historical records --
                              // normal Edit must never reach the modal for
                              // them (backend also rejects the update
                              // directly, in case this is ever bypassed).
                              // Same rule for every role, including Admin --
                              // no restore/reactivate flow exists here.
                              onClick={() =>
                                !product.is_discarded &&
                                setEditingProduct({
                                  ...product,
                                  purchase_date: toDateInput(product.purchase_date),
                                  warranty_date: toDateInput(product.warranty_date),
                                  warranty_expiry_date: toDateInput(product.warranty_expiry_date),
                                })
                              }
                            >
                              <i className="fa-solid fa-pen" aria-hidden="true"></i>
                            </Button>
                          )}

                          {canDelete && (
                            <Button
                              className="unit-icon-btn unit-delete"
                              title="Delete"
                              aria-label={`Delete ${product.name || "product"}`}
                              onClick={() => handleDelete(product.id)}
                            >
                              <i className="fa-solid fa-trash" aria-hidden="true"></i>
                            </Button>
                          )}

                          {canEdit && !product.is_discarded && product.useful_life_value != null && (
                            <Button
                              className="unit-icon-btn unit-edit"
                              title="Review Product Life"
                              aria-label={`Review product life for ${product.name || "product"}`}
                              onClick={() => openReviewModal(product)}
                            >
                              <i className="fa-solid fa-magnifying-glass-chart" aria-hidden="true"></i>
                            </Button>
                          )}

                          {canDiscard && !product.is_discarded && (
                            <Button
                              // UX fix: this is the manual Discard action
                              // (PUT /products/:id/discard -- retires the
                              // product, preserves its row/history/audit
                              // trail) -- NOT hard delete (handleDelete
                              // above, DELETE /products/:id). It previously
                              // shared `.unit-delete`'s red danger styling
                              // AND a dumpster icon with the real Delete
                              // button right next to it, making the two
                              // visually indistinguishable. `.unit-edit`'s
                              // amber/warning styling (already used for
                              // Edit/Review Product Life/Print in this same
                              // row -- this codebase's "administrative,
                              // non-destructive action" tier, not literally
                              // edit-only) reads as "significant action,
                              // pay attention" without implying irreversible
                              // deletion. fa-box-archive replaces
                              // fa-dumpster for the same reason -- "archive/
                              // retire this item" instead of "trash it".
                              className="unit-icon-btn unit-edit"
                              title="Discard Product"
                              aria-label={`Discard ${product.name || "product"}`}
                              onClick={() => openDiscardModal(product)}
                            >
                              <i className="fa-solid fa-box-archive" aria-hidden="true"></i>
                            </Button>
                          )}

                          <Button
                            className="unit-icon-btn unit-edit"
                            title="Print"
                            aria-label={`Print stock sheet for ${product.name || "product"}`}
                            onClick={() => printProductSingle(product)}
                          >
                            <i className="fa-solid fa-print" aria-hidden="true"></i>
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="18">
                      <div className="unit-empty">
                        <div className="unit-empty-icon">
                          <i className="fa-solid fa-boxes-stacked" aria-hidden="true"></i>
                        </div>
                        <h5>No products found</h5>
                        <p>Try another keyword or add a new product.</p>

                        {canCreate && (
                          <Button
                            className="unit-btn unit-btn-primary"
                            onClick={openAddModal}
                          >
                            <i className="fa-solid fa-plus" aria-hidden="true"></i>
                            Add Product
                          </Button>
                        )}
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>

        <div className="unit-footer">
          <div className="unit-count-text">
            Showing{" "}
            <strong>{filtered.length === 0 ? 0 : (page - 1) * perPage + 1}</strong>{" "}
            to <strong>{Math.min(page * perPage, filtered.length)}</strong> of{" "}
            <strong>{filtered.length}</strong> entries
          </div>

          {totalPages > 1 && (
            <Pagination className="unit-pagination">
              <Pagination.Prev
                disabled={page <= 1}
                onClick={() => setPage((prev) => Math.max(1, prev - 1))}
              />

              {compactPageItems([...Array(totalPages)].map((_, index) => (
                <Pagination.Item
                  key={index + 1}
                  active={index + 1 === page}
                  onClick={() => setPage(index + 1)}
                >
                  {index + 1}
                </Pagination.Item>
              )), page)}

              <Pagination.Next
                disabled={page >= totalPages}
                onClick={() => setPage((prev) => Math.min(totalPages, prev + 1))}
              />
            </Pagination>
          )}
        </div>
      </div>

      <Modal
        show={!!editingProduct}
        onHide={() => setEditingProduct(null)}
        centered
        scrollable
        size="lg"
        className="unit-modal unit-compact-modal"
        dialogClassName="admin-teal-modal admin-teal-modal-lg"
        backdropClassName="admin-teal-backdrop"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {isEditMode ? "Edit Product" : "Add Product"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {!isEditMode ? (
            <div className="unit-selected-box">
              <strong>SKU Auto Generate:</strong> SKU will be generated automatically after save.
              <div className="unit-sku-note">
                Enter multiple serial numbers separated by comma or new line.
              </div>
            </div>
          ) : (
            <div className="unit-selected-box">
              <strong>SKU:</strong> {editingProduct?.sku || "-"}
              <div className="unit-sku-note">
                SKU is system generated and cannot be changed.
              </div>
              <div className="text-muted small mt-1">
                Created: {formatDate(editingProduct?.created_at)} &nbsp;|&nbsp; Last
                Updated: {formatDate(editingProduct?.updated_at)}
              </div>
            </div>
          )}

          <div className="row g-2">
            <div className="col-md-6">
              <Form.Label>
                Product Name <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                placeholder="Product name"
                value={editingProduct?.name || ""}
                onChange={(e) => setEditField("name", e.target.value)}
              />
            </div>

            <div className="col-md-3">
              <Form.Label>Category</Form.Label>
              <Form.Control
                placeholder="Category"
                value={editingProduct?.category || ""}
                onChange={(e) => setEditField("category", e.target.value)}
              />
            </div>

            <div className="col-md-3">
              <Form.Label>Brand</Form.Label>
              <Form.Control
                placeholder="Brand"
                value={editingProduct?.brand || ""}
                onChange={(e) => setEditField("brand", e.target.value)}
              />
            </div>

            <div className="col-md-4">
              <Form.Label>Model No.</Form.Label>
              <Form.Control
                placeholder="Model No."
                value={editingProduct?.model_no || ""}
                onChange={(e) => setEditField("model_no", e.target.value)}
              />
            </div>

            <div className="col-md-8">
              {isEditMode ? (
                <>
                  <Form.Label>Serial No.</Form.Label>
                  <Form.Control
                    placeholder="Serial No."
                    value={editingProduct?.serial_no || ""}
                    onChange={(e) => setEditField("serial_no", e.target.value)}
                  />
                </>
              ) : (
                <>
                  <Form.Label>
                    Serial Numbers <span className="text-danger">*</span>
                    {serialCount > 0 ? (
                      <span className="unit-serial-count"> {serialCount} item(s)</span>
                    ) : null}
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    placeholder={"SN001, SN002, SN003\nOr enter one serial number per line"}
                    value={editingProduct?.serial_numbers || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      const count = parseSerialList(value).length;

                      setEditingProduct((prev) => ({
                        ...(prev || {}),
                        serial_numbers: value,
                        qty: count || 1,
                      }));
                    }}
                  />
                </>
              )}
            </div>

            <div className="col-md-4">
              <Form.Label>Purchase Date</Form.Label>
              <Form.Control
                type="date"
                value={editingProduct?.purchase_date || ""}
                onChange={(e) => {
                  const value = e.target.value;

                  setEditingProduct((prev) => ({
                    ...(prev || {}),
                    purchase_date: value,
                    warranty_date: prev?.warranty_date || value,
                  }));
                }}
              />
            </div>

            <div className="col-md-4">
              <Form.Label>Warranty Start Date</Form.Label>
              <Form.Control
                type="date"
                value={editingProduct?.warranty_date || ""}
                onChange={(e) => setEditField("warranty_date", e.target.value)}
              />
            </div>

            <div className="col-md-4">
              <Form.Label>Warranty Expiry Date</Form.Label>
              <Form.Control
                type="date"
                value={editingProduct?.warranty_expiry_date || ""}
                onChange={(e) => setEditField("warranty_expiry_date", e.target.value)}
              />
            </div>

            <div className="col-12">
              <hr className="my-1" />
              <Form.Label className="fw-bold">
                Product Life <small className="text-muted fw-normal">(expected useful life -- separate from Warranty; optional for historical products)</small>
              </Form.Label>
            </div>

            <div className="col-md-3">
              <Form.Label>Product Life Value</Form.Label>
              <Form.Control
                type="number"
                min="1"
                step="1"
                placeholder="e.g. 5"
                value={editingProduct?.useful_life_value ?? ""}
                onChange={(e) => setEditField("useful_life_value", e.target.value)}
              />
            </div>

            <div className="col-md-3">
              <Form.Label>Unit</Form.Label>
              <Form.Select
                value={editingProduct?.useful_life_unit || "YEARS"}
                onChange={(e) => setEditField("useful_life_unit", e.target.value)}
              >
                <option value="YEARS">Years</option>
                <option value="MONTHS">Months</option>
              </Form.Select>
            </div>

            <div className="col-md-6">
              <Form.Label>End Life Date</Form.Label>
              <div>
                <div className="text-muted small" data-testid="ipl-end-life-preview">
                  {(() => {
                    // Live: recalculated as Purchase Date / Life / Unit change;
                    // a Life Review override still wins (backend rule).
                    const end = endLifeFormState({
                      purchaseDate: editingProduct?.purchase_date,
                      lifeValue: editingProduct?.useful_life_value,
                      lifeUnit: editingProduct?.useful_life_unit,
                      overrideEndDate: isEditMode ? editingProduct?.expected_life_override_end_date : null,
                    });
                    if (!end.date) return end.hint;
                    return `${formatDate(end.date)}${end.overridden ? " (revised by Life Review)" : ""}`;
                  })()}
                  {isEditMode && editingProduct?.remaining_life_label
                    ? ` • ${editingProduct.remaining_life_label}`
                    : ""}
                </div>
                {isEditMode && getLifecycleBadge(editingProduct?.lifecycle)}
              </div>
            </div>

            <div className="col-md-5">
              <Form.Label>Processor</Form.Label>
              <Form.Control
                placeholder="Processor"
                value={editingProduct?.processor || ""}
                onChange={(e) => setEditField("processor", e.target.value)}
              />
            </div>

            <div className="col-md-2">
              <Form.Label>RAM GB</Form.Label>
              <Form.Control
                type="number"
                min="0"
                value={editingProduct?.ram_gb ?? ""}
                onChange={(e) => setEditField("ram_gb", e.target.value)}
              />
            </div>

            <div className="col-md-2">
              <Form.Label>SSD GB</Form.Label>
              <Form.Control
                type="number"
                min="0"
                value={editingProduct?.ssd_gb ?? ""}
                onChange={(e) => setEditField("ssd_gb", e.target.value)}
              />
            </div>

            <div className="col-md-3">
              <Form.Label>HDD GB</Form.Label>
              <Form.Control
                type="number"
                min="0"
                value={editingProduct?.hdd_gb ?? ""}
                onChange={(e) => setEditField("hdd_gb", e.target.value)}
              />
            </div>

            <div className="col-md-4">
              <Form.Label>Price</Form.Label>
              <Form.Control
                type="number"
                min="0"
                value={editingProduct?.price ?? ""}
                onChange={(e) => setEditField("price", e.target.value)}
              />
            </div>

            <div className="col-md-4">
              <Form.Label>Qty</Form.Label>
              <Form.Control
                type="number"
                min="0"
                disabled={!isEditMode && serialCount > 0}
                value={editingProduct?.qty ?? ""}
                onChange={(e) => setEditField("qty", e.target.value)}
              />
            </div>

            <div className="col-md-4">
              <Form.Label>Status</Form.Label>
              <Form.Select
                value={editingProduct?.status || "ACTIVE"}
                onChange={(e) => setEditField("status", e.target.value)}
              >
                <option value="ACTIVE">ACTIVE</option>
                <option value="INACTIVE">INACTIVE</option>
              </Form.Select>
            </div>

            <div className="col-12">
              <Form.Label>Accessories</Form.Label>

              <div className="unit-accessory-wrap">
                {[
                  ["has_cpu", "CPU Unit"],
                  ["has_monitor", "Monitor"],
                  ["has_mouse", "Mouse"],
                  ["has_keyboard", "Keyboard"],
                  ["has_adapter", "Adapter"],
                ].map(([key, label]) => (
                  <Form.Check
                    key={key}
                    inline
                    type="checkbox"
                    label={label}
                    checked={!!editingProduct?.[key]}
                    onChange={(e) => setEditField(key, e.target.checked)}
                  />
                ))}
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            className="unit-btn unit-btn-light"
            onClick={() => setEditingProduct(null)}
            disabled={saving}
          >
            <i className="fa-solid fa-arrow-left" aria-hidden="true"></i>
            Cancel
          </Button>

          <Button
            className="unit-btn unit-btn-primary"
            onClick={() => handleSave(editingProduct)}
            disabled={saving}
          >
            {saving ? (
              <>
                <Spinner animation="border" size="sm" />
                Saving...
              </>
            ) : (
              <>
                <i className="fa-solid fa-floppy-disk" aria-hidden="true"></i>
                {!isEditMode && serialCount > 1
                  ? `Save ${serialCount} Products`
                  : "Save Product"}
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <ProductHistoryModal
        product={selectedProduct}
        show={historyOpen}
        onHide={() => setHistoryOpen(false)}
      />

      <Modal
        show={!!discardTarget}
        onHide={() => setDiscardTarget(null)}
        centered
        className="unit-modal"
        dialogClassName="admin-teal-modal"
        backdropClassName="admin-teal-backdrop"
      >
        <Modal.Header closeButton>
          <Modal.Title>Discard Product</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="unit-selected-box mb-3">
            <div>
              <strong>{discardTarget?.name}</strong> / {discardTarget?.sku}
            </div>
            <div className="text-muted small">
              Purchase Date: {formatDate(discardTarget?.purchase_date)} &nbsp;•&nbsp; Asset Life:{" "}
              {discardTarget?.useful_life_label || "—"} &nbsp;•&nbsp; End Life Date:{" "}
              {formatDate(discardTarget?.expected_end_date)}
              {discardTarget?.expected_life_override_end_date ? " (revised by Life Review)" : ""}
            </div>
            <div className="mt-1">
              Life Status: {getLifecycleBadge(discardTarget?.lifecycle)}
            </div>
          </div>

          <div className="row g-2">
            <div className="col-md-6">
              <Form.Label>
                Discard Date <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="date"
                max={todayInputDate()}
                value={discardForm.discard_date}
                onChange={(e) => setDiscardForm((prev) => ({ ...prev, discard_date: e.target.value }))}
              />
            </div>

            <div className="col-md-6">
              <Form.Label>
                Reason <span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                value={discardForm.reason}
                onChange={(e) => setDiscardForm((prev) => ({ ...prev, reason: e.target.value }))}
              >
                <option value="">Select Reason</option>
                {DISCARD_REASONS.map(([value, label]) => (
                  <option key={value} value={value}>
                    {label}
                  </option>
                ))}
              </Form.Select>
            </div>

            <div className="col-md-4">
              <Form.Label htmlFor="ipl-disposal-method">
                Disposal Method <span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                id="ipl-disposal-method"
                value={discardForm.disposal_method}
                onChange={(e) => setDiscardForm((prev) => ({ ...prev, disposal_method: e.target.value }))}
              >
                <option value="">Select Method</option>
                {DISPOSAL_METHODS.map(([value, label]) => (
                  <option key={value} value={value}>
                    {label}
                  </option>
                ))}
              </Form.Select>
            </div>

            <div className="col-md-4">
              <Form.Label htmlFor="ipl-auction-date">
                Auction Date {discardForm.disposal_method === "AUCTION" && <span className="text-danger">*</span>}
              </Form.Label>
              <Form.Control
                id="ipl-auction-date"
                type="date"
                value={discardForm.auction_date}
                onChange={(e) => setDiscardForm((prev) => ({ ...prev, auction_date: e.target.value }))}
              />
            </div>

            <div className="col-md-4">
              <Form.Label htmlFor="ipl-disposal-amount">Auction / Sale Amount</Form.Label>
              <Form.Control
                id="ipl-disposal-amount"
                type="number"
                min="0"
                step="0.01"
                placeholder="0.00"
                value={discardForm.disposal_amount}
                onChange={(e) => setDiscardForm((prev) => ({ ...prev, disposal_amount: e.target.value }))}
              />
            </div>

            <div className="col-12">
              <Form.Label>
                Remarks {discardForm.reason === "OTHER" && <span className="text-danger">*</span>}
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                placeholder="Optional remarks"
                value={discardForm.remarks}
                onChange={(e) => setDiscardForm((prev) => ({ ...prev, remarks: e.target.value }))}
              />
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button className="unit-btn unit-btn-light" onClick={() => setDiscardTarget(null)} disabled={discarding}>
            Cancel
          </Button>
          <Button className="unit-btn unit-btn-primary" onClick={submitDiscard} disabled={discarding}>
            {discarding ? (
              <>
                <Spinner animation="border" size="sm" />
                Discarding...
              </>
            ) : (
              "Discard Product"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={!!reviewTarget}
        onHide={() => setReviewTarget(null)}
        centered
        className="unit-modal"
        dialogClassName="admin-teal-modal"
        backdropClassName="admin-teal-backdrop"
      >
        <Modal.Header closeButton>
          <Modal.Title>Review Product Life</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="unit-selected-box mb-3">
            <div>
              <strong>{reviewTarget?.name}</strong> / {reviewTarget?.sku}
            </div>
            <div className="text-muted small">
              Original Product Life: {reviewTarget?.useful_life_label || "—"} &nbsp;•&nbsp; Expected End:{" "}
              {formatDate(reviewTarget?.expected_end_date)}
            </div>
            <div className="mt-1">Current: {getLifecycleBadge(reviewTarget?.lifecycle)}</div>
            <div className="text-muted small mt-1">
              This review is for audit/planning only -- it is not required to allocate this product.
            </div>
          </div>

          <div className="row g-2">
            <div className="col-md-6">
              <Form.Label>
                Condition <span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                value={reviewForm.condition}
                onChange={(e) => setReviewForm((prev) => ({ ...prev, condition: e.target.value }))}
              >
                <option value="">Select Condition</option>
                {LIFE_REVIEW_CONDITIONS.map((c) => (
                  <option key={c} value={c}>
                    {c.charAt(0) + c.slice(1).toLowerCase()}
                  </option>
                ))}
              </Form.Select>
            </div>

            <div className="col-md-6">
              <Form.Label>Decision</Form.Label>
              <Form.Select value={reviewForm.decision} disabled>
                <option value="CONTINUE_IN_USE">Continue In Use</option>
              </Form.Select>
            </div>

            <div className="col-md-6">
              <Form.Label>Optional Revised Expected End Date</Form.Label>
              <Form.Control
                type="date"
                value={reviewForm.revised_expected_end_date}
                onChange={(e) => setReviewForm((prev) => ({ ...prev, revised_expected_end_date: e.target.value }))}
              />
            </div>

            <div className="col-12">
              <Form.Label>Remarks</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                placeholder="e.g. Battery replaced; laptop working properly."
                value={reviewForm.remarks}
                onChange={(e) => setReviewForm((prev) => ({ ...prev, remarks: e.target.value }))}
              />
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button className="unit-btn unit-btn-light" onClick={() => setReviewTarget(null)} disabled={reviewing}>
            Cancel
          </Button>
          <Button className="unit-btn unit-btn-primary" onClick={submitReview} disabled={reviewing}>
            {reviewing ? (
              <>
                <Spinner animation="border" size="sm" />
                Saving...
              </>
            ) : (
              "Save Review"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}